/**
 * News filters
 */

$(() => {
  if ( !$('body').hasClass('blog') ) {
    return;
  }

  const $types = $('[data-filter="type"]');

  const checkboxHandler = function($checkboxes){
    const $self = $(this);

    // Prevent multiple selections of all and something else
    if ( $self.is(':checked') ) {
      if ( $self.val() === 'all' ) {
        // We just checked "all" so uncheck everything else
        $checkboxes.filter('[value!=all]').prop('checked', false);
      } else {
        // We just checked one of the other types, so uncheck "all"
        $checkboxes.filter('[value=all]').prop('checked', false);
      }
    }

    // Prevent nothing from being checked at all
    if ( !$checkboxes.filter(':checked').length ) {
      $checkboxes.filter('[value=all]').prop('checked', true);
    }


    // Process resulting checkbox states to generate jq selectors
    let typesFilter = [];
    $types.filter(':checked').each(function(){
      typesFilter.push($(this).val());
    });

    let typesQuery = typesFilter.join();

    const currentPath = window.location.pathname,
      currentQuerystring = window.location.search.replace('?', '');
    let newQuerystring = '';
    if ( typesQuery !== 'all' ) {
      let qs = `types=${typesQuery}`;
      if ( currentQuerystring.match(/types=[^&]+/) ) {
        newQuerystring = currentQuerystring.replace(/types=[^&]+/, qs)
      } else if ( currentQuerystring === '' ) {
        newQuerystring = qs
      } else {
        newQuerystring = `${currentQuerystring}&${qs}`
      }
    } else {
      newQuerystring = currentQuerystring.replace(/types=[^&]+/, '');
    }
    window.location.href = `${currentPath}?${newQuerystring}`

  };

  $types.on('change', function(){
    checkboxHandler.call(this, $types)
  });
})